import { render } from "./FormData.vue?vue&type=template&id=34dbb691&scoped=true&lang=html"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"

import "./FormData.vue?vue&type=style&index=0&id=34dbb691&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dbb691"]])

export default __exports__